<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">{{ this.pageName }}</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">Settings</li>
                            <li class="breadcrumb-item active">{{ this.pageName }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>{{ this.pageName }}</h4>
                </div>
                <div class="card-body">
                    <section class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>Loyalty Reward Status</label>
                                        <select name="" class="form-control"
                                                v-model="configuration.loyalty_reward_status">
                                            <option value="yes">Active</option>
                                            <option value="no">Inactive</option>
                                        </select>
                                        <span v-if="configuration.errors.loyalty_reward_status"
                                              class="text-danger text-small">{{ configuration.errors.loyalty_reward_status }}</span>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group"><label>Loyalty Reward Exchange Rate</label>
                                        <input type="number" required class="form-control"
                                               v-model="configuration.loyalty_reward_value">
                                        <span v-if="configuration.errors.loyalty_reward_value"
                                              class="text-danger text-small">{{ configuration.errors.loyalty_reward_value }}</span>
                                    </div>
                                </div>
<!--                                <div class="col-12 col-sm-6">-->
<!--                                    <div class="form-group"><label>Loyalty Reward Type</label>-->
<!--                                        <select name="" class="form-control"-->
<!--                                                v-model="configuration.loyalty_reward_type">-->
<!--                                            <option v-for='(key,value) in loyaltyRewardTypeOptions' :key='key'-->
<!--                                                    :value="key">-->
<!--                                                {{ value }}-->
<!--                                            </option>-->
<!--                                        </select>-->
<!--                                        <span v-if="configuration.errors.loyalty_reward_type"-->
<!--                                              class="text-danger text-small">{{ configuration.errors.loyalty_reward_type }}</span>-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group"><label>Loyalty Reward Point for Amount</label>
                                        <input type="number" required class="form-control"
                                               v-model="configuration.loyalty_reward_point">
                                        <span v-if="configuration.errors.loyalty_reward_point"
                                              class="text-danger text-small">{{ configuration.errors.loyalty_reward_point }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary" @click="updateLoyaltySettings">
                                    Update
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import QuillEditor from '../../Shared/QuillEditor';
import GalleryModal from "@/Shared/GalleryModal";

export default {
    metaInfo: {title: 'Configurations'},
    props: [
        'configurations',
        'configurationEnums',
        'pageName',
        'routeName',
        'loyaltyRewardTypeOptions',
    ],
    layout: Layout,
    name: 'ConfigurationIndex',
    mixins: [
        DeleteAlert,
        PaginationMixin,
    ],
    data() {
        return {
            saving: false,
            configuration: this.$inertia.form({
                loyalty_reward_status: null,
                loyalty_reward_type: null,
                loyalty_reward_value: null,
                loyalty_reward_point: null,
            }),
        };
    },
    mounted() {
        this.configuration.loyalty_reward_status = this.configurations.loyalty_reward_status;
        this.configuration.loyalty_reward_type = this.configurations.loyalty_reward_type ?? "percentage";
        this.configuration.loyalty_reward_value = this.configurations.loyalty_reward_value;
        this.configuration.loyalty_reward_point = this.configurations.loyalty_reward_point;
    },

    methods: {
        async updateLoyaltySettings() {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false;
                },
                onError: () => {
                    this.saving = false;
                }
            };

            this.configuration.post(route(this.routeName), options);
            this.saving = false;
        },
    }
}
</script>
